<template>
      <ins id="adsbygoogle" class="adsbygoogle"
        style="display:block !important"
        data-ad-client="ca-pub-6711015484900349"
        data-ad-slot="5268012972"
        data-ad-format="auto"
        data-full-width-responsive="true"></ins>
</template>

<script>
import postscribe from "postscribe";

export default {
  name: "GoogleAd",
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        console.log("postscribe");
          var adscript = "<script type=\"text/javascript\" src=\"https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js\"><\/script>" +
          "<script type=\"text/javascript\">(adsbygoogle = window.adsbygoogle || []).push({});console.log(\"Running Postscribe 2\");<\/script>";
          console.log(adscript);
          postscribe(
            "#adsbygoogle",
            adscript
            );
      },600);
      
    })
  },
};
</script>